<script setup lang="ts">
import type { Benutzer } from '@/models/Benutzer'

defineProps<{
  benutzer: Benutzer | null
}>()
</script>

<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-btn text v-bind="props">
        <v-icon color="grey darken-1">fas fa-user</v-icon>
        <span class="ml-2 d-none d-md-inline"
          >{{ benutzer?.profilAdresse?.vorname }} {{ benutzer?.profilAdresse?.nachname }}</span
        >
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item class="d-flex d-md-none">
        <v-list-item-title>{{ benutzer?.email }}</v-list-item-title>
      </v-list-item>
      <v-divider class="d-block d-md-none" />
      <v-list-item @click="$emit('profil')" prepend-icon="fas fa-user">
        <v-list-item-title>{{ $t('change_my_data') }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$router.push({ name: 'change_pw' })" prepend-icon="fas fa-key">
        <v-list-item-title>{{ $t('change_my_password') }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$router.push({ name: 'change_email' })" prepend-icon="fas fa-at">
        <v-list-item-title>{{ $t('change_my_email') }}</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item @click="$emit('logout')" prepend-icon="fas fa-sign-out-alt">
        <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
